import { configureStore } from "@reduxjs/toolkit";
import { apiSlice } from "../features/api/apiSlice";
import projectsSlice from "../features/api/Projects/projectsSlice";
import searchSlice from "../features/api/Search/searchSlice";
import tasksSlice from "../features/api/Tasks/tasksSlice";
import teamMembersSlice from "../features/api/teamMembers/teamMembersSlice";

export const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    tasks: tasksSlice,
    projects: projectsSlice,
    teamMembers: teamMembersSlice,
    search: searchSlice,
  },
  devTools: process.env.NODE_ENV !== "production",
  middleware: (getDefaultMiddlewares) =>
    getDefaultMiddlewares().concat(apiSlice.middleware),
});
